const step = {
  LOADING: 0,
  DONATION_TYPE: 1,
  INFORMATION: 2,
  CASE: 3,
  DONOR: 4,
  DONATION_DETAILS: 5,
  PAYMENT_AND_DELIVERY: 6,
  SUMMARY: 7,
  PAYMENT: 8,
  SUCCESS: 9,
}

export default {
  step
}
